import script from "./ComputeSizePage.vue?vue&type=script&lang=ts&setup=true"
export * from "./ComputeSizePage.vue?vue&type=script&lang=ts&setup=true"

import "./ComputeSizePage.vue?vue&type=style&index=0&id=685e98f4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-685e98f4"]])

export default __exports__